import { useQuery } from "@tanstack/react-query";
import { SystemLicenses } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
export const LICENSE_EVENT_DEFINITION_TEMPLATES_QUERY_KEY = "license-event-definition-templates";
const getLicenseEvenDefinitionTemplates = async () => SystemLicenses.getEventDefinitions();
const useLicenseEventDefinitionTemplates = ({ enabled } = { enabled: true }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [LICENSE_EVENT_DEFINITION_TEMPLATES_QUERY_KEY],
    queryFn: () => defaultOnError(
      getLicenseEvenDefinitionTemplates(),
      "Loading license event definition templates failed",
      "Could not load license event definition templates"
    ),
    enabled
  });
  return {
    data: data != null ? data : [],
    isLoading,
    refetch
  };
};
export default useLicenseEventDefinitionTemplates;
